import Repository from "./Repository";
import Question from "../types/Question";

const resource = "/question";

export default {
  save(question: Question) {
    if (question.questionId) {
      return Repository.patch(`${resource}/${question.questionId}`, question);
    } else {
      return Repository.post(`${resource}`, question);
    }
  },
  delete(questionId: string) {
    return Repository.delete(`${resource}/${questionId}`);
  }
};
